<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>{{'help.contact.shortLabel' | translate}}</h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-list dense>
            <mat-list-item>
                <mat-icon class="list-icon" matListIcon>phone</mat-icon>
                <p matLine> +32 (0)69 669 518 </p>
            </mat-list-item>
            <mat-list-item>
                <mat-icon class="list-icon" matListIcon>email</mat-icon>
                <p matLine> contact@symia.be </p>
            </mat-list-item>
        </mat-list>

        <div [innerHTML]="'help.contact.detail' | translate"></div>
    </mat-card-content>
</mat-card>
